import type { UseQueryResult } from '@tanstack/react-query';
import { useApiProblem, type AriPushHistoryItem, type AriPushHistoryResponse } from '@/shared/api';
import { Button } from '@/shared/components';
import { PushHistoryList } from './PushHistoryList';

/**
 * „Zuletzt übertragen" im Reiter Preise & Belegung: was an Channex ging, mit Werten und
 * Rückprüfung. Liest nur das lokale Protokoll, nie Channex selbst.
 */
export function PushHistoryCard({
  history,
  currency,
  onReapply,
}: {
  history: UseQueryResult<AriPushHistoryResponse>;
  currency: string;
  onReapply?: ((item: AriPushHistoryItem) => void) | undefined;
}) {
  const problem = useApiProblem(history.error);
  return (
    <section
      aria-labelledby="push-history-title"
      className="bg-card border-line/50 shadow-card rounded-lg border p-6"
    >
      <div className="mb-4">
        <h2
          id="push-history-title"
          className="text-ink-soft text-[11px] font-semibold uppercase tracking-[0.12em]"
        >
          Zuletzt übertragen
        </h2>
        <p className="text-ink-faint mt-1 text-xs">
          Was an Channex ging und ob die Rückprüfung es bestätigt hat.
          {onReapply && ' „Erneut" lädt einen Zeitraum zurück in die Bearbeitung.'}
        </p>
      </div>
      {history.isError ? (
        <div role="alert" className="space-y-2">
          <p className="text-sealwax text-sm">
            Der Verlauf konnte nicht geladen werden{problem?.detail ? `: ${problem.detail}` : '.'}
          </p>
          <Button type="button" variant="ghost" onClick={() => void history.refetch()}>
            Erneut laden
          </Button>
        </div>
      ) : history.isPending ? (
        <p className="text-ink-faint text-sm" aria-live="polite">
          Verlauf wird geladen …
        </p>
      ) : (
        <PushHistoryList
          items={history.data?.items ?? []}
          currency={currency}
          onReapply={onReapply}
        />
      )}
    </section>
  );
}
